import { createSlice, createEntityAdapter, PayloadAction, EntityState } from '@reduxjs/toolkit';
import ActionState, { ActionStatus } from 'store/ActionState';
import Customer, { GetCustomerOptions, ListCustomersOptions } from 'gql/Customer';

export type CustomerState = {
  customer?: Customer | null;
  fetchCustomerState: ActionState;
  customers: EntityState<Customer>;
  fetchCustomersState: ActionState;
};

export const customerAdapter = createEntityAdapter<Customer>();

export const initialState: CustomerState = {
  customer: null,
  fetchCustomerState: { status: ActionStatus.IDLE },

  customers: customerAdapter.getInitialState(),
  fetchCustomersState: { status: ActionStatus.IDLE },
};

const CustomerSlice = createSlice({
  name: 'customer',
  initialState,
  reducers: {
    fetchCustomer: (state, _: PayloadAction<GetCustomerOptions>): CustomerState => {
      return { ...state, fetchCustomerState: { status: ActionStatus.PROCESSING } };
    },
    fetchCustomerSucceeded: (state, action: PayloadAction<Customer | undefined>): CustomerState => {
      return {
        ...state,
        customer: action.payload,
        fetchCustomerState: { status: ActionStatus.SUCCEEDED },
      };
    },
    fetchCustomerFailed: (state, action: PayloadAction<Error>): CustomerState => {
      return {
        ...state,
        fetchCustomerState: { status: ActionStatus.FAILED, error: action.payload },
      };
    },
    clearCustomerState: (state): CustomerState => {
      return {
        ...state,
        customer: initialState.customer,
        fetchCustomerState: initialState.fetchCustomerState,
      };
    },
    fetchCustomers: (state, _: PayloadAction<ListCustomersOptions | undefined>): CustomerState => {
      return {
        ...state,
        fetchCustomersState: { status: ActionStatus.PROCESSING },
      };
    },
    fetchCustomersSucceeded: (state, action: PayloadAction<Customer[]>): CustomerState => {
      return {
        ...state,
        customers:
          action.payload.length === 0
            ? state.customers
            : customerAdapter.upsertMany({ ...state.customers }, action.payload),
        fetchCustomersState: { status: ActionStatus.SUCCEEDED },
      };
    },
    fetchCustomersFailed: (state, action: PayloadAction<Error>): CustomerState => {
      return {
        ...state,
        fetchCustomersState: { status: ActionStatus.FAILED, error: action.payload },
      };
    },
  },
});

export default CustomerSlice;
